export default __webpack_public_path__ + "tokopedia.png";